import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ConstantData } from './constants';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() { }
  emailValidator(control: AbstractControl): { [key: string]: any } | null {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (control.value && !emailPattern.test(control.value)) {
      return { 'invalidEmail': true };
    }

    return null;
  }


//   phoneNumberValidator(control: AbstractControl): { [key: string]: any } | null {
//     const numericRegex = /^[0-9]*$/;

//     if (!numericRegex.test(control.value)) {
//       return { 'notOnlyNumbers': true };
//     }

//     return null;
//  }
 phoneNumberValidator( control: AbstractControl): { [key: string]: any } | null  {
  // Define a regular expression for Indian phone numbers
  const phoneRegex = /^[6789]\d{9}$/;

  // Remove non-digit characters from the phone number
  const numericPhoneNumber = control.value.replace(/\D/g, '');

  // Check if the numeric phone number matches the defined pattern
  return phoneRegex.test(numericPhoneNumber)? null : { 'notOnlyNumbers': true };
}

dateValidator(isAdultValidation:boolean,control: AbstractControl): { [key: string]: boolean } | null {
  const value = control.value;

  if (!value) {
    // If the value is empty, don't perform validation (allowing for optional fields)
    return null;
  }

  // Check if the value is a valid date in "DD/MM/YYYY" format
  const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

  if (!regex.test(value)) {
    return { 'invalidDate': true };
  }

  // Convert the input date string to a Date object
  const inputDate = new Date(value.split('/').reverse().join('/'));

  // Get today's date
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to 0 for comparison

  // Check if the input date is greater than today's date
  if (inputDate > today) {
    return { 'dateGreaterThanToday': true };
  }

  // Calculate age in years
  const ageInMilliseconds = today.getTime() - inputDate.getTime();
  const ageInYears = Math.floor(ageInMilliseconds / (365.25 * 24 * 60 * 60 * 1000));

  // Check if the age is less than 21 years
  if (ageInYears < ConstantData.adultAge && isAdultValidation) {
    return { 'ageLessThan21': true };
  }

  return null;
}
}
